// 🔐 Connexion P4 — fiche employé → résumé du compte : « N appareils connectés » (propriétaire), ouvre le dialogue Appareils.
import { useEffect, useState } from 'react';
import axios from 'axios';
import { DialogueAppareils } from '@/components/securite/Appareils';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('auth_token')}` });

export function CompteurAppareils({ utilisateur }) {
  const [n, setN] = useState(null);
  const [ouvert, setOuvert] = useState(false);
  const charger = () => axios.get(`${API_URL}/api/auth/users/${utilisateur.id}/sessions`, { headers: headers() }).then((r) => setN(r.data.sessions.length)).catch(() => setN(null));
  useEffect(() => { charger(); }, [utilisateur.id]); // eslint-disable-line react-hooks/exhaustive-deps
  if (n === null) return null;
  return (
    <>
      <button type="button" className="text-xs text-blue-600 hover:underline" onClick={() => setOuvert(true)} data-testid="compteur-appareils">{n} appareil{n > 1 ? 's' : ''} connecté{n > 1 ? 's' : ''}</button>
      <DialogueAppareils utilisateur={utilisateur} open={ouvert} onClose={() => { setOuvert(false); charger(); }} />
    </>
  );
}
